export default [
  {
    path: '',
    redirect: '/data-overview',
    component: loadView('views/layout/layout'),
    children: [
      {
        path: 'data-overview',
        name: 'data-overview',
        meta: {
          label: '定制数据总览',
        },
        component: loadView('views/data-overview'),
      },
      {
        path: 'custom-made',
        name: 'custom-made',
        meta: {
          label: '客户定制',
        },
        component: loadView('views/custom-made'),
      },
      {
        path: 'index-swiper',
        name: 'index-swiper',
        meta: {
          label: '首页轮播配置',
        },
        component: loadView('views/index-swiper/index-swiper.vue'),
      },
      {
        path: 'product-manage',
        name: 'product-manage',
        meta: {
          label: '商品管理',
        },
        component: loadView('views/product-manage'),
        children: [
          {
            path: 'ordinary-product',
            name: 'ordinary-product',
            meta: {
              label: '普通商品',
            },
            component: loadView('views/product-manage/ordinary-product'),
          },
          {
            path: 'functional-product',
            name: 'functional-product',
            meta: {
              label: '功能性商品',
            },
            component: loadView('views/product-manage/functional-product'),
          },
        ],
      },
      {
        path: 'course',
        name: 'course',
        meta: {
          label: '课程培训',
        },
        component: loadView('views/course'),
        children: [
          {
            path: 'course-list',
            name: 'course-list',
            meta: {
              label: '课程管理',
            },
            component: loadView('views/course/course-list.vue'),
          },
          {
            path: 'course-user',
            name: 'course-user',
            meta: {
              label: '人员管理',
            },
            component: loadView('views/course/course-user.vue'),
          },
        ],
      },
      {
        path: 'packaging',
        name: 'packaging',
        meta: {
          label: '包装管理',
        },
        component: loadView('views/packaging'),
        children: [
          {
            path: 'packaging-gnxsp',
            name: 'packaging-gnxsp',
            meta: {
              label: '功能性食品',
            },
            component: loadView('views/packaging/packaging-gnxsp.vue'),
          },
          {
            path: 'packaging-bjp',
            name: 'packaging-bjp',
            meta: {
              label: '保健品',
            },
            component: loadView('views/packaging/packaging-bjp.vue'),
          },
          {
            path: 'packaging-template',
            name: 'packaging-template',
            meta: {
              label: '包装模板管理',
            },
            component: loadView('views/packaging/packaging-template.vue'),
          },
        ],
      },
    ],
  },
]

function loadView(path) {
  return () => import(/* webpackChunkName: "chunk-[request][index]" */ `@/${path}`)
}
